// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  onTime: __t.u32().name("on_time"),
  late: __t.u32(),
  defaults: __t.u32(),
  repaidLoans: __t.u32().name("repaid_loans"),
  kindsMask: __t.u32().name("kinds_mask"),
  openedAt: __t.timestamp().name("opened_at"),
  lastDefaultAt: __t.timestamp().name("last_default_at"),
  bannedUntil: __t.timestamp().name("banned_until"),
});
